module.exports = __webpack_public_path__ + "static/img/img_banner_pc.fae1678.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/_images/img_banner_pc.png
// module id = yPRj
// module chunks = 0